import { createFileRoute, redirect } from '@tanstack/react-router';

/** Older links to /admin open the Setup hub, which picks the first tab the user may see. */
export const Route = createFileRoute('/_app/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/setup', replace: true });
  },
});
